import {useEffect, useState} from "react";
import {shallowEqual, useSelector} from "react-redux";
import {isContestRoute} from "../../../utils/commonMethods";

export function useGetProbeData(probeId, isPortfolio, eventData) {
  let isContestRoute1 = isContestRoute();
  let liveState = useSelector(({liveReducer}) => {
    const probe = {
      ...(isContestRoute1
        ? liveReducer?.byContestIds?.[probeId]
        : liveReducer?.byIds?.[probeId] || {}),
    };
    delete probe["volume"];
    delete probe["timestamp"];
    delete probe["channel"];
    return probe;
  }, shallowEqual);

  let live = liveState;

  let livePortfolio = useSelector(({portfolioReducer}) =>
    isContestRoute1
      ? portfolioReducer?.portfolioDataContest1?.[probeId]
      : portfolioReducer?.data1?.[probeId],
  );

  let activeMarketLoading = useSelector(
    ({portfolioReducer}) => portfolioReducer?.activeMarketLoading,
  );
  // let data = {};
  // data = portfolioReducer?.data1[];
  // data = (livePortfolio?.probes ?? []).filter((probe) => {
  //   return probe.id == probeId;
  // });
  let data = livePortfolio;
  // data = data.length && data[0];

  // Added for the case where the it is new event
  // and user has no shares when on single event page
  if (!data && !isPortfolio) {
    data = eventData;
  }
  let probeData = {};
  //const [probeData, setProbeData] = useState({});
  //let probeData = {};
  //useEffect(() => {
  if (Object.keys(live).length || data) {
    if (!data?.["is_price_editable"]) {
      var newSellPriceYes = live?.exPriceYes ?? data.newSellPriceYes;
      var newSellPriceNo = live?.exPriceNo ?? data.newSellPriceNo;
    } else {
      newSellPriceYes = live?.newNCP
        ? 100 - live?.newNCP
        : data.newSellPriceYes;
      newSellPriceNo = live?.newYCP ? 100 - live?.newYCP : data.newSellPriceNo;
    }
    if (!data?.["is_price_editable"]) {
      var bestPriceYes = live?.sellYCP ?? eventData?.sellYCP;
      var bestPriceNo = live?.sellNCP ?? eventData?.sellNCP;
    } else {
      bestPriceYes = live?.newNCP ? 100 - live?.newNCP : data.newSellPriceYes;
      bestPriceNo = live?.newYCP ? 100 - live?.newYCP : data.newSellPriceNo;
    }

    probeData = {
      execution_price_yes: newSellPriceYes,
      execution_price_no: newSellPriceNo,
      total_matched_contract_yes: data.total_matched_contract_yes,
      total_matched_contract_no: data.total_matched_contract_no,
      isDataLoading: activeMarketLoading,
      newYCP: bestPriceYes,
      newNCP: bestPriceNo,
    };
    //setProbeData(probeData1);
  }
  return probeData;
}
